import ApiClient from '@afosto/api/ApiClient';

class Printers {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Attach an inbox to the printer
   *
   * @param {string} id - ID of printer to attach the inbox to
   * @param {Object} body - The new printer configuration
   * @param {Object} options - The additional request options
   * @description Update a printer to a new configuration
   * @returns {Promise}
   */
  attachInbox(id, body, options = {}) {
    return this.apiClient.request({
      url: `/spl/printers/${id}/inbox`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * Add a printer
   *
   * @param {Object} body - The new printer
   * @param {Object} options - The additional request options
   * @description Add a new printer
   * @returns {Promise}
   */
  createPrinter(body, options = {}) {
    return this.apiClient.request({
      url: `/spl/printers`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Deletes a printer
   *
   * @param {string} id - ID of printer to delete
   * @param {Object} options - The additional request options
   * @description Disables a printer
   * @returns {Promise}
   */
  deletePrinter(id, options = {}) {
    return this.apiClient.request({
      url: `/spl/printers/${id}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * Get the printer
   *
   * @param {string} id - ID of printer to return
   * @param {Object} options - The additional request options
   * @description Returns a single printer
   * @returns {Promise}
   */
  getPrinter(id, options = {}) {
    return this.apiClient.request({
      url: `/spl/printers/${id}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * List the hooked printers
   *
   * @param {Object} query - The optional path parameters
   * @param {string} [query.hubId] - ID of hub to filter for
   * @param {string} [query.inboxId] - ID of inbox to filter for
   * @param {Object} options - The additional request options
   * @description Returns a list of active printers
   * @returns {Promise}
   */
  listPrinters(query = {}, options = {}) {
    const params = {
      hub_id: query.hubId,
      inbox_id: query.inboxId,
    };

    return this.apiClient.request({
      url: `/spl/printers`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * Update a printer
   *
   * @param {string} id - ID of printer to update
   * @param {Object} body - The new printer configuration
   * @param {Object} options - The additional request options
   * @description Update a printer to a new configuration
   * @returns {Promise}
   */
  updatePrinter(id, body, options = {}) {
    return this.apiClient.request({
      url: `/spl/printers/${id}`,
      method: 'put',
      data: body,
      ...options,
    });
  }
}

export const printers = new Printers();

export default Printers;
